import React from "react";
import { Card, CardBody, CardTitle, Spinner } from "reactstrap";
import { ConnectComponentsProvider, ConnectAccountManagement } from "@stripe/react-connect-js";
import { useStripeConnect } from "./StripeConnectContext";

/**
 * Lets the landlord view/update their payout bank account and other
 * Stripe-required account details directly inside Porcher. Stripe stays
 * the source of truth for this data — nothing is mirrored into Firestore.
 */
const StripePayoutAccount = () => {
  const { status, connectInstance } = useStripeConnect();

  if (!status?.onboardingComplete) return null;

  return (
    <Card className="mb-4">
      <CardBody>
        <CardTitle tag="h5" className="mb-3">Payout Account</CardTitle>

        {connectInstance ? (
          <ConnectComponentsProvider connectInstance={connectInstance}>
            <ConnectAccountManagement />
          </ConnectComponentsProvider>
        ) : (
          <div className="text-center py-4"><Spinner color="primary" /></div>
        )}
      </CardBody>
    </Card>
  );
};

export default StripePayoutAccount;
